const SET_CURRENT_DAY = (state, { day, week }) => {
    state.currentDay = day;
    state.currentWeekNumber = week;
};
const SET_SELECTED_CALENDAR_DAY = (state, day) => {
    state.selectedDay = day;
};
const CLEAR_DATE_INFO = (state) => {
    state.currentDay = '';
    state.currentWeekNumber = null;
};
export default {
    CLEAR_DATE_INFO,
    SET_CURRENT_DAY,
    SET_SELECTED_CALENDAR_DAY
};
